import { HeroUIProvider } from "@heroui/react"
import type { LinksFunction, LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare"
import { json } from "@remix-run/cloudflare"
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
  useMatches,
  useNavigate
} from "@remix-run/react"
import { useTranslation } from "react-i18next"
import { useChangeLanguage } from "remix-i18next/react"
import { DialogProvider } from "~/components/dialog"
import { i18next } from "./i18n.server"
import "./tailwind.css"
import { CloudflareENV } from "./lib/interfaces"

export const links: LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous"
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
  }
]

export const meta: MetaFunction = () => {
  return [{ title: "Cambodia Carbon Registry" }]
}

export async function loader({ request, context }: LoaderFunctionArgs) {
  const locale = await i18next.getLocale(request)
  const env = context.cloudflare.env as CloudflareENV
  return json({ locale, GA_ID: env.GA_ID })
}

export function Layout({ children }: Readonly<{ children: React.ReactNode }>) {
  const { locale, GA_ID } = useLoaderData<typeof loader>() ?? {}
  const { i18n } = useTranslation()

  useChangeLanguage(locale)

  return (
    <html lang={locale} dir={i18n.dir()}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_ID}');
          `
          }}
        />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export default function App() {
  const navigate = useNavigate()

  return (
    <HeroUIProvider navigate={navigate}>
      <DialogProvider>
        <Outlet />
      </DialogProvider>
    </HeroUIProvider>
  )
}
